import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import map from 'lodash/map'
import Spacer from 'atoms/Spacer'
import ItemsGrid from 'atoms/ItemsGrid'
import Item from './Item'
import ItemAdd from './ItemAdd'

export default class ScheduleEditorItemsGrid extends Component {
  static propTypes = {
    weekDayItems: PropTypes.object.isRequired,
    onItemChange: PropTypes.func.isRequired,
    onItemDelete: PropTypes.func.isRequired,
    onItemAdd: PropTypes.func.isRequired,
    addFormTitle: PropTypes.string.isRequired,
    editFormTitle: PropTypes.string.isRequired,
  }

  handleItemChange = item => (nextItem) => {
    const { onItemChange } = this.props
    onItemChange(item, nextItem)
  }

  handleItemDelete = item => () => {
    const { onItemDelete } = this.props
    onItemDelete(item)
  }

  renderItem = (item, index) => {
    const { addFormTitle, editFormTitle } = this.props
    return (
      <Item
        key={index}
        item={item}
        onChange={this.handleItemChange(item)}
        onDelete={this.handleItemDelete(item)}
        addFormTitle={addFormTitle}
        editFormTitle={editFormTitle}
      />
    )
  }

  renderWeekDay = (items, weekDay) => {
    const { onItemAdd, addFormTitle, editFormTitle } = this.props
    return (
      <Fragment key={weekDay}>
        <Spacer />
        <ItemsGrid spacing={16}>
          { items.map(this.renderItem) }
          <ItemAdd
            weekDay={parseInt(weekDay, 10)}
            onItemAdd={onItemAdd}
            addFormTitle={addFormTitle}
            editFormTitle={editFormTitle}
          />
        </ItemsGrid>
      </Fragment>
    )
  }

  render() {
    const { weekDayItems } = this.props
    return map(weekDayItems, this.renderWeekDay)
  }
}
